import React from 'react';
import Infographic from '../Infographic/Infographic';
import './Sections.scss';

function Section2() {
  return (
    <section className="sections sections-marginBox">
      <div className="sections-section2">
        <Infographic />
        <p className="sections-copy sections-copy-section2">
          This yearning for more space seems to be shared among all buyers. “First-time buyers may
          have been renting a tiny apartment, living with roommates, or staying with family members.
          Now they want a home of their own in which to spread their wings. But this year,
          first-time buyers made up 26 percent of home purchases, down from last year’s 34 percent.
          This is the lowest share of first-time buyers since the data collection began,” says
          Lautz. “Repeat buyers may need a larger home because they have become a multigenerational
          household—whether that means caring for aging parents, welcoming a new baby, or
          accommodating a young adult boomeranging back. In any case, we see that more space is a
          universal motivation for both first-time and repeat home buyers.”
        </p>
      </div>
    </section>
  );
}

export default Section2;
